var _circle, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVoz = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#374899"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91766 7.94908C9.72428 7.51974 9.52098 7.50987 9.33752 7.50494C9.18876 7.5 9.01522 7.5 8.84167 7.5C8.66812 7.5 8.39045 7.56415 8.15244 7.82077C7.91444 8.07738 7.25 8.69918 7.25 9.96745C7.25 11.2308 8.17723 12.4546 8.30615 12.6274C8.43507 12.8001 10.0962 15.4797 12.7192 16.5111C14.9009 17.3698 15.3472 17.1971 15.8182 17.1527C16.2893 17.1083 17.3454 16.5309 17.5636 15.9288C17.7768 15.3268 17.7768 14.8135 17.7124 14.705C17.6479 14.5964 17.4744 14.5322 17.2165 14.4039C16.9587 14.2756 15.6893 13.6538 15.4513 13.565C15.2133 13.4811 15.0398 13.4367 14.8712 13.6933C14.6976 13.9499 14.2018 14.5273 14.053 14.7C13.9043 14.8728 13.7506 14.8925 13.4927 14.7642C13.2349 14.6359 12.4019 14.3645 11.4151 13.486C10.6466 12.805 10.1259 11.9612 9.97716 11.7045C9.82841 11.4479 9.96228 11.3097 10.0912 11.1814C10.2052 11.0679 10.349 10.8804 10.478 10.7324C10.6069 10.5843 10.6515 10.4758 10.7358 10.303C10.8201 10.1303 10.7804 9.98226 10.716 9.85395C10.6515 9.73058 10.1457 8.45737 9.91766 7.94908Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVoz, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/voz.ae11273a.svg";
export { ForwardRef as ReactComponent };